import styled from 'styled-components';
import { Button } from '../../actions/Button';

export const TransparentOverlay = styled.div`
  background-color: #ffffff80; // TODO put this somewhere
  position: absolute;
  top: -1px; /* also over the component border */
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 1;
`;

export const RaisedButton = styled(Button)`
  z-index: 2;
`;

export const TRANSPARENT_OVERLAY = 'TRANSPARENT_OVERLAY';
